

<template>
    <div style="display:none;">
        <div class="col-md-3">
            <aside class="category-filters">
                <div class="category-filters-section-tender">
                    <h3 class="widget-title-sm-tender">Latest Tender</h3>
                </div>
                    <div class="category-filters-section-tenderdetail" v-for="tender in tenders">
                    <h3 style="color:#020202;font-size:17px;"><a href="">{{tender.Agency}}</a></h3>
                        <div>
                            <p style="color:#020202;font-size:13px;">{{tender.Title}}</p>
                            <p></p>
                            <p style="color:#020202;font-size:13px;">{{formatDate(tender.ClosingDate)}}</p>
                        </div>
                </div>
            </aside>
             <aside class="category-filters">
                <div class="category-filters-section-tender">
                    <h3 class="widget-title-sm-tender">Latest RFQ</h3>
                </div>
                <div class="category-filters-section-tenderdetail" v-for="tender in rfq">
                    <h3 style="color:#020202;font-size:17px;"><a href="">{{tender.Agency}}</a></h3>
                        <div>
                            <p style="color:#020202;font-size:13px;">{{tender.Title}}</p>
                            <p></p>
                            <p style="color:#020202;font-size:13px;">{{formatDate(tender.ClosingDate)}}</p>
                        </div>
                </div>
            </aside>
        </div>
        <div class="col-md-3">
           
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import stringHelper from '../lib/stringHelper'

export default {
    created() {
        this.$store.dispatch('categories/fetchRfqTenderList')
    },
	computed: {
		...mapState('categories', [
            'tenders',
            'rfq'
        ])
    },
    methods: {
        formatDate(date) {
            return stringHelper.formatDate(date);
        }
    }
}
</script>
